module.exports = __webpack_public_path__ + "static/media/logo.0ae3d4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo.png
// module id = 633
// module chunks = 0